import { TestimonialStoriesPopup } from './TestimonialStoriesPopup';
import { ViewedVideos } from './ViewedVideos';

export class TestimonialStories extends ViewedVideos {
    constructor({previousArrow, nextArrow, userStoriesSelector, numberOfSlides}) {
        super();
        this.previousArrow = previousArrow;
        this.nextArrow = nextArrow;
        this.userStoriesSelector = userStoriesSelector;
        this.numberOfSlides = numberOfSlides;
        this.init();
    };

    init() {
        this.addToLocalStorage();
        this.checkViewed(true);

        $('.testimonial-stories').on('init', (event, slick) => {
            $('.testimonial-stories').addClass('show');
            if (slick.slideCount > slick.options.slidesToShow) {
                $(this.nextArrow[0]).addClass('show');
            };
        }).slick({
            slidesToShow: this.numberOfSlides,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            swipeToSlide: false,
            draggable: false,
            edgeFriction: 0.05,
            touchThreshold: 100,
            rows: 0,
            respondTo: 'slider',
            prevArrow: $('#story-prev'),
            nextArrow: $('#story-next'),
            slide: '.user-story-container',
            responsive: [
                {
                    breakpoint: 1239,
                    settings: {
                        swipeToSlide: true,
                        draggable: true,
                        slidesToShow: 10
                    }
                }, {
                    breakpoint: 900,
                    settings: {
                        swipeToSlide: true,
                        draggable: true,
                        slidesToShow: 8
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        arrows: false,
                        swipeToSlide: true,
                        draggable: true,
                        slidesToShow: 5
                    }
                }, {
                    breakpoint: 500,
                    settings: {
                        arrows: false,
                        swipeToSlide: true,
                        draggable: true,
                        slidesToShow: 4
                    }
                }
            ]
        });

        $(window).on('resize', () => {
            this.checkViewed();
        });

        $('.testimonial-stories').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            if (slick.slideCount === slick.options.slidesToShow) return;
            if(nextSlide === (slick.slideCount-slick.options.slidesToShow)) {
                $(this.previousArrow[0]).removeClass('hide').addClass('show');
                $(this.nextArrow[0]).addClass('hide');
            } else if (nextSlide === 0) {
                $(this.previousArrow[0]).addClass('hide');
                $(this.nextArrow[0]).removeClass('hide').addClass('show');
            } else {
                $(this.previousArrow[0]).removeClass('hide').addClass('show');
                $(this.nextArrow[0]).removeClass('hide').addClass('show');
            }
        });

        $('.testimonial-stories').on('breakpoint', () => {
            this.checkViewed();
        });
    
        $('.testimonial-stories').on('click', this.userStoriesSelector, (event) => {
            new TestimonialStoriesPopup({
                userId: $(event.currentTarget).data('user-id'),
            }).openPopup();
        });
    };

};